export default __webpack_public_path__ + "static/darkMode-26ea6c045747dce9205bf3341afa6b74.png";